import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {RootState } from "../Core/Store";

const initialState: any = {
    selectedBucket:0,
    bucketCount:0,
    bucketSize:""
};

const runningPeriodOptionSlice = createSlice({
  name: "runningPeriodOptions",
  initialState,
  reducers: {
    nextBucket: (state, action: PayloadAction<string>) => {
        if (state.selectedBucket < state.bucketCount - 1){
            state.selectedBucket += 1
        }
    },
    previousBucket:(state, action: PayloadAction<string>) => {
        if (state.selectedBucket > 0){
            state.selectedBucket -= 1
        }
    },
    resetSelectedBucket:(state, action: PayloadAction<string>) => {
            state.selectedBucket = 0;
    },
    updateSliceBucketSize:(state, action: PayloadAction<string>) => {
        
        state.bucketSize = action.payload
    },
    updateSliceBucketCount:(state, action: PayloadAction<string>) => {
        
        state.bucketCount = action.payload
    }
  }
});

export const { nextBucket,previousBucket,updateSliceBucketSize,resetSelectedBucket,updateSliceBucketCount } = runningPeriodOptionSlice.actions;

export const getRunningPeriodsOptionsSelector = (state: RootState) => state.runningPeriodOptions;

export default runningPeriodOptionSlice.reducer;